import { API } from "../../apiSlice";

export const loanScheduleApiSlice = API.injectEndpoints({
  endpoints: (builder) => ({
    loanSchedule: builder.mutation({
      query: (data) => {
        return {
          url: "users/calculate-loan-schedule",
          method: "POST",
          body: data,
        };
      },
    }),
  }),
});

export const { useLoanScheduleMutation } = loanScheduleApiSlice;
